import { HrmActions } from "../../pages/components/hrm_actions";

export const adminMetaInfoColumns = ({ onSelectAction }) => {
  return [
    {
      Header: "Sr. No.",
      accessor: "idd", // Assuming you set 'idd' correctly in the data
      Cell: ({ row }) => {
        return row.original.idd; // Return the idd value
      },
    },
    {
      Header: "Page",
      accessor: (row) => {
        return row?.page || "N/A";
      },
    },
    {
      Header: "Meta Title",
      accessor: (row) => {
        return row?.meta_title || "N/A";
      },
    },
    {
      Header: "Meta Description",
      // accessor: (row) => {
      //   return row?.meta_description || "N/A";
      // },
      accessor: (row) => {
        return (
          <><HrmActions
            onSelectAction={onSelectAction}
            row={row}
            view={true}
            datas={row?.meta_description}
          /></>
        );
      },
    },
    {
      Header: "Actions",
      accessor: (row) => {
        return (
          <div className="text-left">
            <HrmActions
              onSelectAction={onSelectAction}
              row={row}
              isDefault={true}
            />
          </div>
        );
      },
    },
  ];
};
